<!-- message.vue -->
<template>
  <div class="echojoy-message" >
    <p>{{content}}</p>
  </div>
</template>
<script>
export default {
  name: "message",
  data(){
		return{
			content: "",
			duration: 1000
		}
	},
  // mounted() {
  //   setTimeout(() => {
	// 		// 1s 后通过父级移除子元素的方式来移除该组件实例和 DOM 节点
	// 		this.$destroy(true);
	// 		this.$el.parentNode.removeChild(this.$el);
	// 	}, this.duration);
  // },
};
</script>
<style lang="scss" scoped>
.echojoy-message {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  color: #fff;
  z-index: 9999;
  background: transparent;
  > p {
    padding: 12px 22px;
    font-size: 18px;
    border-radius: 4px;
    background: rgba(17, 17, 17, 0.7);
   }
}
</style>


// WEBPACK FOOTER //
// src/components/message/message.vue